// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"ImagePopover__srOnly--qlunH","hiddenInput":"ImagePopover__hiddenInput--S812G","root":"ImagePopover__root--1YJGR"};